import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PopupPage from '../PopupPage';
import styles from './styles';

class PopupTemplate02 extends React.Component {
  renderAside() {
    const { popupData, baseUrl, classes, color, colorTextAside } = this.props;
    const textColor = `text-${colorTextAside}`;
    return (
      <div className={`${classes.asideBlock} ${classes[color]}`}>
        {popupData.asides.map((item, idx) => (
          <div key={idx} className={`${classes.aside} ${classes[textColor]} ${item.imageLeft ? classes.imgLeft : ''}`}>
            {item.image && item.imageLeft && (
              <img src={`${baseUrl}/popups/${parse(item.image)}`} alt="" className={classes.asideImage} />
            )}
            <div>
              {item.title && (
                <Typography variant="h6" className={classes.asideTitle}>
                  {parse(item.title)}
                </Typography>
              )}
              {item.text && (
                <Typography variant="body1" className={classes.asideText}>
                  {parse(item.text)}
                </Typography>
              )}
            </div>
            {item.image && !item.imageLeft && (
              <img src={`${baseUrl}/popups/${parse(item.image)}`} alt="" className={classes.asideImage} />
            )}
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { popupData, classes, color, open, baseUrl, onClose } = this.props;
    const hasImage = popupData.imgSrc !== undefined && popupData.imgSrc !== '';
    const imgSrc = hasImage ? `${baseUrl}/popups/${parse(popupData.imgSrc)}` : null;
    const hasImageText = popupData.imgTextSrc !== undefined && popupData.imgTextSrc !== '';
    const imgTextSrc = hasImageText ? `${baseUrl}/popups/${parse(popupData.imgTextSrc)}` : null;
    const hasAside = popupData.asides !== undefined;
    const colorText = `text-${color}`;

    return (
      <PopupPage open={open} onClose={onClose}>
        <Typography variant="h3" className={`${classes.title} ${classes[colorText]}`}>
          {parse(popupData.title)}
        </Typography>
        {imgSrc && <img src={imgSrc} alt="" className={classes.image} />}
        <div className={classes.textWrapper}>
          <div className={classes.desc}>
            <Typography variant="body1">{parse(popupData.column1)}</Typography>
          </div>
          {imgTextSrc && <img src={imgTextSrc} alt="" className={classes.imageText} />}
          {popupData.column2 && (
            <div className={classes.desc}>
              <Typography variant="body1">{parse(popupData.column2)}</Typography>
            </div>
          )}
        </div>
        {hasAside ? this.renderAside() : null}
      </PopupPage>
    );
  }
}

PopupTemplate02.propTypes = {
  popupData: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  baseUrl: PropTypes.string,
  color: PropTypes.string,
  colorTextAside: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default withStyles(styles)(PopupTemplate02);
